import React from "react";
import "./style.scss";

const Button = ({ text, classname, onClick }) => {
  return (
    <button className={classname} onClick={onClick} data-cokies="cookies">
      {text}
    </button>
  );
};

export default Button;
